const updates = [
  {
    date: '07-30',
    title: '《狂飙》全集高清上线',
    desc: '现象级扫黑剧全集免费开放，4K画质流畅不卡顿',
    tag: '新上线',
  },
  {
    date: '07-29',
    title: '暑期档专题页面上线',
    desc: '精选暑期热门影视，一站畅享暑假观影时光',
    tag: '专题',
  },
  {
    date: '07-28',
    title: '《莲花楼》更新至完结',
    desc: '古装探案剧全集免费看，成毅主演口碑爆棚',
    tag: '完结',
  },
  {
    date: '07-27',
    title: '播放器升级至V3.2版本',
    desc: '新增智能画质调节，弱网环境也能流畅播放',
    tag: '升级',
  },
  {
    date: '07-25',
    title: '《三体》电视剧完整版上线',
    desc: '科幻巨制全集高清免费，震撼视觉不容错过',
    tag: '推荐',
  },
  {
    date: '07-23',
    title: '日漫专区新增50部番剧',
    desc: '热门日漫《咒术回战》《鬼灭之刃》等全收录',
    tag: '新增',
  },
  {
    date: '07-20',
    title: 'CDN节点扩容完成',
    desc: '全国新增100+加速节点，观看更流畅不缓冲',
    tag: '优化',
  },
  {
    date: '07-18',
    title: '韩剧《黑暗荣耀》全集上线',
    desc: '高分复仇爽剧免费看，宋慧乔演技封神之作',
    tag: '热门',
  },
];

const tagColors: Record<string, string> = {
  '新上线': 'bg-primary-100 text-primary-700',
  '专题': 'bg-accent-100 text-accent-700',
  '完结': 'bg-secondary-100 text-secondary-700',
  '升级': 'bg-primary-100 text-primary-700',
  '推荐': 'bg-accent-100 text-accent-700',
  '新增': 'bg-secondary-100 text-secondary-700',
  '优化': 'bg-primary-100 text-primary-700',
  '热门': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              片库更新、功能升级一手掌握
            </p>
          </div>

          <div className="max-w-3xl mx-auto relative">
            <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300 hidden md:block"></div>
            <div className="space-y-6">
              {updates.map((item) => (
                <div key={item.date + item.title} className="flex gap-4 md:gap-6">
                  <div className="hidden md:flex flex-col items-center pt-1">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500 z-10"></div>
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                    <div className="flex items-center gap-2 flex-wrap mb-2">
                      <span className="text-xs font-medium text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                        {item.date}
                      </span>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagColors[item.tag] || 'bg-background-100 text-foreground-500'}`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}